import * as React from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';

import { useChannelsModalStore } from 'stores/ChannelsModalStore';

import ChannelForm from './ChannelForm';
import Creation from './Creation';

import './CreationContainer.modules.scss';

type Props = {
  showContent?: boolean;
};

const CreationContainer: React.FC<Props> = ({ showContent = true }) => {
  const { store } = useChannelsModalStore();

  return (
    <div
      styleName={cn(
        'creation-container',
        !store.bot && 'creation-container_bordered'
      )}
    >
      {showContent && (
        <>
          <Creation />
          <ChannelForm />
        </>
      )}
    </div>
  );
};

export default observer(CreationContainer);
